/** 
 * @description: 账单列表
 * @author: cyp
 * @update: hwx
 */
<template>
    <div class="bill-manage">
        <div class="bill-list" v-show="!showdetail">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div @click="clearDate" ref="time">
                      <input type="text" class="form-control laydate-icon" v-model="startTime"> -
                      <input type="text" class="form-control laydate-icon" v-model="endTime">
                    </div>
                </div>
                <label class="list-label-4">消费门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="billshop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-4">消费包厢:</label>
                <div class="col-md-2 ct-col">
                    <div class="input-group">
                        <input type="text" class="form-control" ref="billshoproom" placeholder="请选择包厢" readonly />
                        <div class="input-group-btn">
                            <ul class="dropdown-menu dropdown-menu-right" role="menu"></ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-3">账单号:</label>
                <div class="col-md-2">
                    <div class="input-group">
                        <input type="text" class="form-control" placeholder="请输入账单号" ref="billno">
                        <div class="input-group-btn">
                            <ul class="dropdown-menu dropdown-menu-right" role="menu"></ul>
                        </div>
                    </div>
                </div>
                <label class="list-label-4">预定信息:</label>
                <div class="col-md-2">
                    <div class="input-group">
                        <input id="searchBookMsg" type="text" class="form-control" ref="searchBookMsg" placeholder="请输入预定信息" readonly="readonly" />
                        <div class="input-group-btn">
                            <ul class="dropdown-menu dropdown-menu-right" role="menu"></ul>
                        </div>
                    </div>
                </div>
                <label class="list-label-5">挂账担保人:</label>
                <div class="col-md-2">
                    <input type="text" class="form-control" placeholder="担保人姓名或工号" v-model="bill_hac">
                </div>
                <label class="list-label-4">包厢类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择包厢类型" ref="bill_boxtype"></select>
                </div>
            </div>
            <div class="row">
                <label class="list-label-4">消费金额:</label>
                <span class="list-total">{{billList.consumption_amount_total}}</span>
                <label class="list-label-4">实收金额:</label>
                <span class="list-total">{{billList.amount_total}}</span>
                <label class="list-label-4">退款金额:</label>
                <span class="list-total">{{billList.refund_amount_total}}</span>
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="queryList">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="billlist"></table>
            </div>

            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="export_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='export_allcheck' @click='exportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="shop_name">
                            <label>消费门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="room_name">
                            <label>消费包厢</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="room_area">
                            <label>区域</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="bill_no">
                            <label>账单号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="order_title">
                            <label>开房类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="start_time">
                            <label>开房时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="end_time">
                            <label>结束时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="consumption_amount">
                            <label>消费金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="amount">
                            <label>实收金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="refund_amount">
                            <label>退款金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="book_msg">
                            <label>预定信息</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="invoice_print">
                            <label>发票情况</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="invoice_amount">
                            <label>发票金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="hanging_account_user">
                            <label>挂账担保人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="room_type_name">
                            <label>包厢类型</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='export_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='export_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 账单详情 -->
        <div class="bill-det" v-show="showdetail">
            <billDetail ref="bill_det" @backBdwPre="showdetail = false"></billDetail>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import billDetail from '@/components/bill_detail.vue';
    export default {
        name: 'order_manage',
        data() {
            return {
                showanswer: false,
                showdetail: false,
                theBill: {
                    type: Object
                },
                billList: {},
                startTime: "",
                endTime: "",
                shop_room_name: {
                    value: []
                },
                search_book_msg: {
                    value: []
                },
                goods_list: [],
                tickets_list: [],
                bill_hac: '',

                export_allcheck: false,
                c_export_allcheck: false,
                export_checkModel: [],
                export_checkData: ['shop_name', 'room_name', 'room_area', 'bill_no', 'order_title', 'start_time', 'end_time', 'consumption_amount', 'amount', 'refund_amount', 'book_msg', 'invoice_print', 'invoice_amount', 'hanging_account_user', 'room_type_name'],
                export_type: 1,
            }
        },
        components: {
            "billDetail": billDetail
        },
        filters: {
            formateMoney: function(value) {
                if(value < 0) {
                    return "0.00";
                } else {
                    return(value - 0).toFixed(2);
                }
            }
        },
        watch: {
            export_checkModel: {
                handler: function(val, oldVal) {
                    if(this.export_checkModel.length >= this.export_checkData.length) {
                        this.export_allcheck = true;
                        this.c_export_allcheck = true;
                    } else {
                        this.export_allcheck = false;
                        this.c_export_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
          this.$nextTick(function() {
              let _this = this;
              // 日期
              var myDate = new Date();
              this.IntstartTime = myDate;
              this.IntendTime = new Date(myDate.getTime() + 1 * 24 * 3600 * 1000);
              this.IntstartTime.setHours(8, 0);
              this.IntendTime.setHours(8, 0);
              var timStar = new Date(this.IntstartTime),
                  year = timStar.getFullYear(),
                  month = (timStar.getMonth() + 1) < 10 ? '0' + (timStar.getMonth() + 1) : (timStar.getMonth() + 1),
                  day = timStar.getDate() < 10 ? '0' + timStar.getDate() : timStar.getDate(),
                  hour = timStar.getHours() < 10 ? '0' + timStar.getHours() : timStar.getHours(),
                  minute = timStar.getMinutes() < 10 ? '0' + timStar.getMinutes() : timStar.getMinutes();
              var timEnd = new Date(this.IntendTime),
                  yearend = timEnd.getFullYear(),
                  monthend = (timEnd.getMonth() + 1) < 10 ? '0' + (timEnd.getMonth() + 1) : (timEnd.getMonth() + 1),
                  dayend = timEnd.getDate() < 10 ? '0' + timEnd.getDate() : timEnd.getDate(),
                  hourend = timEnd.getHours() < 10 ? '0' + timEnd.getHours() : timEnd.getHours(),
                  minuteend = timEnd.getMinutes() < 10 ? '0' + timEnd.getMinutes() : timEnd.getMinutes();
              _this.startTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
              _this.endTime = yearend + '-' + monthend + '-' + dayend + ' ' + hourend + ':' + minuteend;
              this.innitDate();
              this.innitInput();
          });
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.time).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: _this.IntstartTime,
                    endDate: _this.IntendTime,
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.startTime = start.format('YYYY-MM-DD HH:mm');
                    _this.endTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 清空日期
            clearDate: function() {
                this.startTime = "";
                this.endTime = "";
            },
            // 初始化门店
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.billshop).select2({
                                data: arr,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    $(_this.$refs.billshoproom).attr("readonly", "readonly");
                                    $(_this.$refs.billshoproom).bsSuggest("disable");
                                    $(_this.$refs.billshoproom).val('').trigger('change');

                                    $(_this.$refs.searchBookMsg).attr("readonly", "readonly");
                                    $(_this.$refs.searchBookMsg).bsSuggest("disable");
                                    $(_this.$refs.searchBookMsg).val('').trigger('change');
                                    // 包厢类型
                                    $(_this.$refs.bill_boxtype).val('').trigger('change');
                                    $(_this.$refs.bill_boxtype).prop("disabled", true);
                                    return;
                                }
                                $(_this.$refs.billshoproom).val('').trigger('change');
                                $(_this.$refs.billshoproom).attr("data-id", '');
                                _this.innitroomInput(e.params.data.id);
                                
                                $(_this.$refs.searchBookMsg).val('').trigger('change');
                                $(_this.$refs.searchBookMsg).attr("data-id", '');
                                _this.innitSearchBookMsgInput(e.params.data.id);
                                // 包厢类型
                                $(_this.$refs.bill_boxtype).prop("disabled", false);
                                _this.getShopBoxType(e.params.data.id);
                            });
                            $(_this.$refs.billshop).val(data.response.result[1].id).trigger('change');

                            _this.innitroomInput(data.response.result[1].id);
                            _this.innitSearchBookMsgInput(data.response.result[1].id);
                            // 包厢类型
                            $(_this.$refs.bill_boxtype).prop("disabled", false);
                            _this.getShopBoxType($(_this.$refs.billshop).val());

                            _this.innitTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 初始化门店包厢
            innitroomInput: function(shop_id) {
                let _this = this;
                let innitSuggest = function() {
                    $(_this.$refs.billshoproom).bsSuggest("destroy");
                    $(_this.$refs.billshoproom).bsSuggest({
                        data: _this.shop_room_name,
                        ignorecase: true,
                        showHeader: false,
                        showBtn: false, //不显示下拉按钮
                        delayUntilKeyup: true,
                        idField: "id",
                        keyField: "name",
                        effectiveFields: ["name"],
                        inputWarnColor: "white",
                    });
                };
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id || "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoom",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.shop_room_name.value = [];
                            $.each(data.response.result, function(k, v) {
                                _this.shop_room_name.value.push({
                                    name: v.name,
                                    id: v.id
                                });
                            });
                            if(_this.shop_room_name.value.length < 1) {
                                $(_this.$refs.billshoproom).attr("readonly","readonly");
                                $(_this.$refs.billshoproom).bsSuggest("disable");
                                $(_this.$refs.billshoproom).val('').trigger('change');
                            } else {
                                $(_this.$refs.billshoproom).removeAttr("readonly");
                                innitSuggest();
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 初始化预定信息
            innitSearchBookMsgInput: function(shop_id) {
                let _this = this;
                let innitSuggest = function() {
                    $(_this.$refs.searchBookMsg).bsSuggest("destroy");
                    $(_this.$refs.searchBookMsg).bsSuggest({
                        data: _this.search_book_msg,
                        ignorecase: true,
                        showHeader: false,
                        showBtn: false, // 不显示下拉按钮
                        delayUntilKeyup: true,
                        idField: "id",
                        keyField: "name",
                        effectiveFields: ["name"],
                        inputWarnColor: "white",
                    });
                };
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id || "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "user/getSearchList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.search_book_msg.value = [];
                            $.each(data.response.result, function(k, v) {
                                _this.search_book_msg.value.push({
                                    name: v.name,
                                    id: v.id
                                });
                            });
                            if( _this.search_book_msg.value.length < 1 ) {
                                $(_this.$refs.searchBookMsg).attr("readonly","readonly");
                                $(_this.$refs.searchBookMsg).bsSuggest("disable");
                                $(_this.$refs.searchBookMsg).val('').trigger('change');
                            } else {
                                $(_this.$refs.searchBookMsg).removeAttr("readonly");
                                innitSuggest();
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取门店下包厢类型
            getShopBoxType: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getRoomType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: ' ', text: '全部' }];
                            $.each(data.response.result.data, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.bill_boxtype).html('');
                            $(_this.$refs.bill_boxtype).select2({
                                data: arr,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.data.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },

            // 初始化账单列表表格
            innitTable: function() {
                let _this = this;
                $(_this.$refs.billlist).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getBillList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "no",
                        title: "账单<br />序号",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "shop_name",
                        title: "消费门店",
                        width: "7%",
                        valign: "middle"
                    }, {
                        field: "room_type_name",
                        title: "包厢<br />类型",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "room_name",
                        title: "消费<br />包厢",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "room_area",
                        title: "区域",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "bill_no",
                        title: "账单号",
                        width: "10%",
                        valign: "middle"
                    }, {
                        field: "order_title",
                        title: "开房类型",
                        width: "7%",
                        valign: "middle"
                    }, {
                        field: "consumption_amount",
                        title: "消费<br />金额",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "amount",
                        title: "实收<br />金额",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "refund_amount",
                        title: "退款<br />金额",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "book_msg",
                        title: "预定<br />信息",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "invoice_print",
                        title: "发票<br />情况",
                        width: "6%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            var value = (value == 1) ? '已开' : '未开';
                            return value;
                        }
                    }, {
                        field: "invoice_amount",
                        title: "发票<br />金额",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "hanging_account_username",
                        title: "挂账<br />担保人",
                        width: "6%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return row.hanging_account_username + ' ' + row.hanging_account_worknumber;
                        }
                    }, {
                        title: "操作",
                        width: "5%",
                        valign: "middle",
                        events: {
                            'click .detail': function(e, value, row) {
                                _this.$refs.bill_det.getBdwDetail(row.bill_no);
                                // _this.getOrderDetail(row.bill_no);
                                _this.showdetail = true;
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue detail">详情</span>'
                        }
                    }]
                });
            },
            // 获取账单列表
            getBillList: function(params) {
                let _this = this,
                    shop_id = $(_this.$refs.billshop).val(),
                    roomid = '',
                    book_msg = '',
                    billno = $(_this.$refs.billno).val(),
                    consumeroomname = $(_this.$refs.consumeroomname).val(),
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                if($(_this.$refs.billshoproom).val() != '') {
                    roomid = $(_this.$refs.billshoproom).attr("data-id");
                }
                if($(_this.$refs.searchBookMsg).val() != '') {
                    book_msg = $(_this.$refs.searchBookMsg).attr("data-id");
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber || 1,
                            "page_size": params.data.limit || 10,
                            "room_id": roomid || "",
                            "shop_id": shop_id || "",
                            "start_date": _this.startTime || "",
                            "end_date":  _this.endTime || "",
                            "bill_no": billno || "",
                            "admin_id": book_msg,
                            "hanging_account_user": _this.bill_hac,
                            "room_type": $.trim($(_this.$refs.bill_boxtype).val())
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                var layIndex = layer.load(0, {
                    shade: [0.1, '#ececec']
                });
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Bill/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.billList = data.response.result;
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.bill_list
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                        layer.close(layIndex);
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                        layer.close(layIndex);
                    }
                });
            },
            // 点击“查询”按钮
            queryList: function() {
                $(this.$refs.billlist).bootstrapTable("destroy");
                this.innitTable();
            },
            // 获取导出设置
            getExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "Bill/export"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.export_checkModel = data.response.result.export_fields;
                                _this.export_type = data.response.result.export_type;
                            } else {
                                _this.export_checkModel = _this.export_checkData;
                                _this.export_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.export_alert)
                }, function() {
                    _this.exportList();
                });
            },
            // 导出字段全选
            exportCheckedAll: function() {
                let _this = this;
                _this.export_allcheck = _this.c_export_allcheck;
                if(!_this.export_allcheck) { // 实现全选
                    _this.export_checkModel = [];
                    _this.export_checkData.forEach(function(item) {
                        _this.export_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.export_checkModel = [];
                }
            },
            // 点击“导出”按钮
            exportList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.billshop).val(),
                    roomid = $(_this.$refs.billshoproom).attr("data-id") || '',
                    book_msg = $(_this.$refs.searchBookMsg).attr("data-id") || '',
                    billno = $(_this.$refs.billno).val(),
                    hanging_account_user = _this.bill_hac || '';
                let export_fields = JSON.stringify(_this.export_checkModel);
                window.location.href = Vue.ctUrl +
                    "Bill/export?shop_id=" + shop_id +
                    "&room_id=" + roomid +
                    "&start_date=" + _this.startTime +
                    "&end_date=" + _this.endTime +
                    "&bill_no=" + billno +
                    "&admin_id=" + book_msg +
                    "&hanging_account_user=" + hanging_account_user +
                    "&room_type=" + $.trim($(_this.$refs.bill_boxtype).val()) +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.export_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less">
    .bill-manage {
        .bill-list {
            .pull-right {
                button {
                    margin: 0 0 0 30px;
                }
            }
            .set-export {
                padding: 0 20px 20px;
                h3 {
                    font-size: 16px;
                }
                li {
                    float: left;
                    width: 20%;
                }
            }
        }
    }
</style>